// extracted by mini-css-extract-plugin
var _1 = "#4c4c4c";
var _2 = "mobileinputs_content__fc4cp";
var _3 = "mobileinputs_contentwrapper__2wv7b";
var _4 = "640px";
var _5 = "790px";
var _6 = "#057676";
var _7 = "#434343";
var _8 = "79px";
var _9 = "110px";
var _a = "72px";
var _b = "665px";
var _c = "teal";
var _d = "2";
var _e = "#cdd3dc";
export { _1 as "body", _2 as "content", _3 as "contentWrapper", _4 as "controlsMobileWidth", _5 as "controlsStackedWidth", _6 as "darkTeal", _7 as "headline", _8 as "menuHeight", _9 as "menuHeightLarge", _a as "menuHeightMobile", _b as "modalMobileWidth", _c as "teal", _d as "timelineStrokeWidth", _e as "timelineTrackColor" }
